import { render, staticRenderFns } from "./CowDetails.vue?vue&type=template&id=137d6b3d&"
import script from "./CowDetails.vue?vue&type=script&lang=js&"
export * from "./CowDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports